export default function (apiKey) {
    return new Promise((resolve, reject) => {
      if (typeof carrotquest === 'undefined') {
        window.carrotquest = {}
        window.carrotquestasync = []
        window.carrotquest.settings = {}
        const n = [
          'connect',
          'track',
          'identify',
          'auth',
          'oth',
          'onReady',
          'addCallback',
          'removeCallback',
          'trackMessageInteraction',
        ]
        for (let a = 0; a < n.length; a++)
          window.carrotquest[n[a]] = function (...argument) {
            window.carrotquestasync.push(n[a], argument)
          }
  
        window.carrotquest.connect(apiKey)
  
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.crossOrigin = 'anonymous'
        script.addEventListener('load', () => {
          resolve(window.carrotquest)
        })
        script.addEventListener('error', (error) => {
          console.error('Failed to load carrotquest script', error);
          reject(new Error(`Failed to load carrotquest script`))
        })
        script.src = '//cdn.carrotquest.app/api.min.js'
        document.querySelectorAll('head')[0].appendChild(script)
      }
    })
  }
  